<template>
  <section class="container-full-5">
    <h2 class="secondary-font mb-6">Transactions carte</h2>
    <p class="text-grey-600">Historique des transactions de votre carte.</p>
    <div class="clear-both h-60" />
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CarteTransactions'
})
</script>
